import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenaricNotesModule } from '@common/notes/notes.module';
import { HistoryModule } from '@common/remmi-history/history.module';
import { FeatureFlagModule } from '@directive/feature-flag/feature-flag.module';
import { GoogleAddressModule } from '@directive/google-address/google-address.module';
import { ReorderPipeModule } from '@pipes/reorder-pipe/reorder.module';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { ProjectAgreementModule } from '../../my-projects/project-agreement/project-agreement.module';
import { ContactPrimeNgModule } from '../contact-primeNg.module';
import { AddOfficeContactComponent } from './add-office-contact.component';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { ContactAlternativeInfoModule } from '../contact-alternative-info/contact-alternative-info.module';

@NgModule({
  declarations: [AddOfficeContactComponent],
  imports: [
    CommonModule,
    ContactPrimeNgModule,
    ProjectAgreementModule,
    GenaricNotesModule,
    ReorderPipeModule,
    FormsModule,
    ReactiveFormsModule,
    GoogleAddressModule,
    CommonSharedModule,
    HistoryModule,
    FeatureFlagModule,
    ReMultipleSelectModule,
    ReMultiselectModule,
    PipeDirectiveModule,
    ContactAlternativeInfoModule,
  ],
  exports: [AddOfficeContactComponent],
})
export class AddOfficeContactModule {}
